import React from 'react';
import Newtab from './Newtab';
import { I18nProvider } from '../../i18n/I18nContext';

const NewTabPage = () => {
  return (
    <I18nProvider>
      <Newtab />
    </I18nProvider>
  );
};

export default NewTabPage; 